export default __webpack_public_path__ + "static/media/svg1.877370a8.png";